import { lazy } from 'solid-js'
import { messages } from '../../pages/home-page/host-home-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/host-home-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/become-a-host',
    titleMessage: messages.titleMessage,
}
